module.exports = __webpack_public_path__ + "img/inside_osakana.7f3e535c.jpg";